<template>
<b-row>
  <b-col sm="6" md="2">
      <label class="form-control-label">{{ $t('views.firm.list.filters.state') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters.state"
          :options="radioOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
  </b-col>
  <b-col sm="12" md="4">
    <div class="form-group">
      <label for="custom_field_type">{{ $t('views.externalform.form.fieldType') }}</label>
      <model-select id="custom_field_type" :options="customFieldTypeOptions" v-model="filters.customFieldType"></model-select>
    </div>
  </b-col>
</b-row>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import debounce from 'v-debounce'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  name: 'CustomFieldFiltering',
  props: {
    customFieldTypeOptions: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ModelSelect
  },
  data () {
    return {
      delay: 500,
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      filters: {
        state: 1,
        customFieldType: null
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        let url = 'e_x_a_b_custom_fields'
        this.getPage(addParamsToQuery(url, this.filters))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    }
  },
  directives: {
    debounce
  }
}
</script>

<style scoped>

</style>
